<template>
  <Modal v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">审核解约协议</div>   
    <Form :model="formData" :label-width="85" :rules="formRules" ref="formValidate">
      <FormItem label="原因/备注" prop="remark">
        <Input v-model="formData.remark" type="textarea" :rows="4" ></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button type="primary" size="large" @click="action" :loading="loading">
          <span>确定</span>
        </Button>
      </div>
    </div>

  </Modal> 
</template>
 
<script type="text/ecmascript-6">
import { confirmSurrAudit } from 'api/termination'
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    surrenderFid:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      loading:false,
      show:false,
      formData :{
        remark:''
      },
      formRules: {
        remark:[{ required: true, type:'string', message:'请填写驳回原因', trigger: 'blur'}],
      }
    };
  },
  watch:{
   n(val){
      this.$refs['formValidate'].resetFields();
     this.show = true;
   }
 },
  methods:{
    cancel(){
      this.show = false
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    action(){
      this.$refs['formValidate'].validate( bool => {
        if(bool) {
          let data = {
            auditType:2,
            surrenderFid:this.surrenderFid,
            noAuditReason:this.formData.remark
          }
          this.loading = true
          confirmSurrAudit(data).then( res => {
            this.loading = false
            this.show = false
            this.$Message.success('驳回成功!');
            this.$emit('closeTag')
          }).catch( res => {
            this.loading = false
          })
        }
      })
      
    }
  }
}
</script>
